// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Kc4w1","reportBodyText":"style__reportBodyText__uXN1O"};